import FileModel from './globals/FileModel';

export default class AdvertiserLogoMediaModel extends FileModel {
  static get path() {
    return '/backend/advertiser_logo_media/{?id}';
  }
}
